import { useEffect, useState } from 'react';
import {
  Box,
  Card, makeStyles,
  Typography,
} from '@material-ui/core';
import PropTypes from 'prop-types';

import graph from '../../assets/icons/foundation_graph-pie.png';

const useStyles = makeStyles((theme) => ({
  statisticsSection: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: theme.spacing(0, 0, 6, 0),
  },
  text: {
    fontFamily: 'Raleway',
    fontSize: '14px',
  },
  statistics: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    background: 'transparent',
    minWidth: 516,
    minHeight: 132,
    border: '5px solid',
    borderColor: '#21456E',
    borderRadius: '10px',
    color: theme.palette.text.default,
  },
  textStatistics: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  contentAvance: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  textItemStatistics: {
    color: theme.palette.background.info,
    fontSize: '35px',
    fontFamily: 'Raleway',
  },
}));

function PanelStatistics({
  numberFinishedLessons, totalLessons, numberPracticalCase, numberQuizz,
}) {
  const classes = useStyles();

  const [percentage, setPercentage] = useState(0);
  const [finishPracticalCase, setfinishPracticalCase] = useState(0);
  const [finishQuizz, setFinishQuizz] = useState(0);

  const getPercentage = () => {
    const result = (100 * numberFinishedLessons) / totalLessons;
    setPercentage(Math.round(result));
  };

  const getFinishedPracticalCase = () => (
    numberPracticalCase.length !== 0 && numberPracticalCase[0].file !== undefined
      ? setfinishPracticalCase(finishPracticalCase + 1)
      : setfinishPracticalCase(0)
  );

  const getFinishedQuizz = () => (
    numberQuizz.length !== 0 && numberQuizz[0].score !== undefined
      ? setFinishQuizz(finishQuizz + 1)
      : setFinishQuizz(0)
  );

  useEffect(() => {
    getPercentage();
    getFinishedPracticalCase();
    getFinishedQuizz();
  }, []);

  return (
    <Card className={classes.statistics}>
      <Box className={classes.contentAvance}>
        <Typography className={classes.text}>Avance</Typography>
        <Box className={classes.textStatistics}>
          <Typography className={classes.textItemStatistics}>
            {percentage}
            {' '}
            %
          </Typography>
          <img src={graph} alt="graph" />
        </Box>
      </Box>
      <Box>
        <Typography className={classes.text}>Lecciones</Typography>
        <Box className={classes.textStatistics}>
          <Typography className={classes.textItemStatistics}>
            {numberFinishedLessons}
            /
            {totalLessons}
          </Typography>
        </Box>
      </Box>
      {numberPracticalCase.length !== 0 || numberQuizz.length !== 0 ? (
        <Box>
          <Typography className={classes.text}>Actividades</Typography>
          <Box className={classes.textStatistics}>
            <Typography className={classes.textItemStatistics}>
              {finishPracticalCase + finishQuizz}
              /
              {numberPracticalCase.length + numberQuizz.length}
            </Typography>
          </Box>
        </Box>
      ) : (
        <Box>
          <Typography className={classes.text}>Actividades</Typography>
          <Box className={classes.textStatistics}>
            <Typography className={classes.textItemStatistics}>
              0
            </Typography>
          </Box>
        </Box>
      )}
    </Card>
  );
}

export default PanelStatistics;

PanelStatistics.propTypes = {
  numberFinishedLessons: PropTypes.number.isRequired,
  totalLessons: PropTypes.number.isRequired,
  numberPracticalCase: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.number,
  ]))).isRequired,
  numberQuizz: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.number,
  ]))).isRequired,
};
